import {enrollmentStatuses} from '@/constants/enrollments.js'
import {computed} from 'vue'

/**
 * Enrollment statuse composable
 */
export function useEnrollmentStatus(enrollment) {

  //Check if enrollment is active. Sort of.
  const isSortOfActive = computed(() => {
    return [
      enrollmentStatuses.ACTIVE,
      enrollmentStatuses.PAUSED,
      enrollmentStatuses.NOT_ENGAGED,
    ].includes(enrollment.value.status)
  })

  //Check if enrollment should show progress
  const showProgress = computed(() => isSortOfActive.value && enrollment.value.numSteps > 1)

  //Expose interface
  return {
    isSortOfActive,
    showProgress,
  }
}
